import { Q2Game } from "./proto/q2_game";


const { ccclass, property } = cc._decorator;

@ccclass
export default class NetMessageDataQ2Game {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //单播消息 游戏信息 登录重连时发送

    static GameInfo: any[] = [null, null, 'Game.GameInfo', Q2Game.GameInfo, 3]    
    static InitNotify: any[] = [null, null, 'Game.InitNotify', Q2Game.InitNotify, 3]    
    static ScoreNotify: any[] = [null, null, 'Game.ScoreNotify', Q2Game.ScoreNotify, 3]    
    static DealCardNotify: any[] = [null, null, 'Game.DealCardNotify', Q2Game.DealCardNotify, 3]    
    static MoreCard: any[] = ['Game.MoreCardReq', Q2Game.MoreCardReq, 'Game.MoreCardRsp', Q2Game.MoreCardRsp, 3]    
    static MoreCardNotify: any[] = [null, null, 'Game.MoreCardNotify', Q2Game.MoreCardNotify, 3]    
    static MoreCardChangedNotify: any[] = [null, null, 'Game.MoreCardChangedNotify', Q2Game.MoreCardChangedNotify, 3]    

    static Raise: any[] = ['Game.RaiseReq', Q2Game.RaiseReq, 'Game.RaiseRsp', Q2Game.RaiseRsp, 3]  
    static RaiseNotify: any[] = [null, null, 'Game.RaiseNotify', Q2Game.RaiseNotify, 3] 
    
    static Attach: any[] = ['Game.AttachReq', Q2Game.AttachReq, 'Game.AttachRsp', Q2Game.AttachRsp, 3]  
    static AttachNotify: any[] = [null, null, 'Game.AttachNotify', Q2Game.AttachNotify, 3] 

    static ShowQ2: any[] = ['Game.ShowQ2Req', Q2Game.ShowQ2Req, 'Game.ShowQ2Rsp', Q2Game.ShowQ2Rsp, 3]  
    static ShowQ2Notify: any[] = [null, null, 'Game.ShowQ2Notify', Q2Game.ShowQ2Notify, 3] 

    static Discard: any[] = ['Game.DiscardReq', Q2Game.DiscardReq, 'Game.DiscardRsp', Q2Game.DiscardRsp, 3]  
    static DiscardNotify: any[] = [null, null, 'Game.DiscardNotify', Q2Game.DiscardNotify, 3] 
    static SeatChangedNotify: any[] = [null, null, 'Game.SeatChangedNotify', Q2Game.SeatChangedNotify, 3] 

    static Storage: any[] = ['Game.StorageReq', Q2Game.StorageReq, 'Game.StorageRsp', Q2Game.StorageRsp, 3]  
    static StorageNotify: any[] = [null, null, 'Game.StorageNotify', Q2Game.StorageNotify, 3] 

    static Complete: any[] = ['Game.CompleteReq', Q2Game.CompleteReq, 'Game.CompleteRsp', Q2Game.CompleteRsp, 3]  

    static GameSettle: any[] = [null, null, 'Game.GameSettle', Q2Game.GameSettle, 3] 

    static TimeoutNotify: any[] = [null, null, 'Game.TimeoutNotify', Q2Game.TimeoutNotify, 3] 

    static AckReq: any[] = ['Game.AckReq', Q2Game.AckReq, null, null, 3]  
    static CardsSequenceChangedReq: any[] = ['Game.CardsSequenceChangedReq', Q2Game.CardsSequenceChangedReq, null, null, 3]  

    static CardReocrderNotify: any[] = [null, null, 'Game.CardReocrderNotify', Q2Game.CardReocrderNotify, 3] 
}

